import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { LoginPageComponent } from './pages/login/login.page';
import { ResetPasswordDialogComponent } from './components/reset-password-dialog/reset-password-dialog.component';
import { Routes, RouterModule } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { FormsModule } from '@angular/forms';
import { AuthGuard } from './guards/auth.guard';
import { LoginService } from './services/login.service';
import { HttpClientModule } from '@angular/common/http';
import { LoginOdooService } from './services/login-odoo.service';
import { TranslateModule } from '@ngx-translate/core';
import { LoginInMemoryService } from './services/login-in-memory.service';
import { environment } from '../../../environments/environment';
import { GeneralModule } from '../general/general.module';
import { LoginPaymentComponent } from './components/login-payment/login-payment.component';
import { LoginStateService } from './services/login-state.service';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ResetPasswordMainComponent } from './components/reset-password-main/reset-password-main.component';
import { LoginGuard } from './guards/login.guard';

const routes: Routes = [
  {
    path: 'login',
    children: [
      {
        path: '',
        canActivate: [LoginGuard],
        component: LoginPageComponent,
        data: {
          title: ['NAME COMPANY', 'LOGIN'],
        },
      },
      {
        path: '**',
        redirectTo: '/login',
      },
    ]
  },
  {
    path: 'forget_pwd',
    component: ResetPasswordMainComponent
  },
];

const loginServiceClass = environment.production ? LoginOdooService : LoginInMemoryService;

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    HttpClientModule,
    FormsModule,
    GeneralModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    LoginComponent,
    LoginPaymentComponent
  ],
  declarations: [
    LoginComponent,
    LoginPageComponent,
    ResetPasswordDialogComponent,
    LoginPaymentComponent,
    ResetPasswordComponent,
    ResetPasswordMainComponent,
  ],
  providers: [
    AuthGuard,
    LoginGuard,
    LoginStateService,
    [{ provide: LoginService, useClass: loginServiceClass }],
  ],
  entryComponents: [ResetPasswordDialogComponent]
})
export class LoginModule { }
